/* eslint:disable */
/* tslint:disable */
// import en from './en/locale-en.json';
const en = require("./locale-en.json");

// Load languages
export default {
  en
};
